<ng-container *ngIf="imageUrlHasValue; else defaultImageTemp">
	<advanced-image [cldImg]="cldImage" [height]="crop === 'limit' ? 'auto' : height" [width]="crop === 'limit' ? 'auto' : width" [plugins]="plugins" [alt]="alt">
	</advanced-image>
</ng-container>

<ng-template #defaultImageTemp>
	<img src="{{ defaultImage }}" alt="{{ alt }}" #phdImage *ngIf="defaultImageHasValue" [attr.height]="height ?? 'auto'" [attr.width]="width ?? 'auto'" />
</ng-template>